export const release = () => `OS Release: 0.1.3
Codename: Bionic Cat
`;
